module.exports = __webpack_public_path__ + "media/images/cz100-acaa7a8e118e343e22d412a091313b69.svg";